import Header from "../Components/Header/Header";
import pulsar from './Images/2his.png'
import gm from './Images/gm.png';
import tbm from './Images/tbn.jpg'
import { Link } from 'react-router-dom';
const Streams1 = () => {

  return(
    <div className="Page">
      <Header />      
   <div className="Stream--Page--Center">

      <div className="Stream--Page--Center">
        <h1>1 поток Сатурнского Хакатона</h1> 
        <h2>5 - 9 Январь 2024 </h2>
      </div>
      <hr />
      <div className="Block">
        <h1>Кейсы</h1>
        <p>В роли заказчика и генерального спонсора выступила Администрация города Олёкминска в лице главы города Сергея Евгеньевича Щеблякова. Администрация выдвинула трек "Сайт для города Олёкминска".</p>
      </div>

      <div className="Block">
        <div className="Project--Container">
          <div className="Project--Avatar">
            <img width={500}  src= {tbm} alt="logo" />          
          </div>
          <div className="Project--Container--Item">
            <div>
              <h2>Команда TBN</h2>
              <h2>Сайт Олекминска</h2>                  
            </div>
            <div>
              <p>Наш проект поможет гостям нашего города лучше ориентироваться по городу. 
                Туристы, вахтовики проше говоря гости нашего города с легкостью смогут перемещаться по нашему городу.  
                Наш сайт поможет найти гостиницу,кафе, памятник.
                На нашем сайте есть очень интересные и увлекательные факты.
              </p>          
            </div>     
            <div>

              <a className="Stream-items--button" href="https://docs.google.com/presentation/d/1NRyWRBgRongih-aEMinaZq_hDTwmuLs-/edit?usp=drive_link&ouid=112515864092591463143&rtpof=true&sd=true">
                <button>Презентация команды</button>            
              </a>
              
            </div>      
          </div>          
        </div>
      </div>

      <div className="Block">
        <div className="Project--Container">
          <div className="Project--Avatar">
            <img width={500} src={pulsar} alt="logo" />          
          </div>
          <div className="Project--Container--Item">
            <div>
              <h2>Команда Pulsar</h2>
              <h2>2his</h2>                  
            </div>
            <div>
              <p>Наш проект поможет гостям нашего города лучше ориентироваться по городу. 
                Туристы, вахтовики проше говоря гости нашего города с легкостью смогут перемещаться по нашему городу.  
                Наш сайт поможет найти гостиницу,кафе, памятник.
                На нашем сайте есть очень интересные и увлекательные факты.
              </p>          
            </div>       
            <div>

              <a className="Stream-items--button" href="https://drive.google.com/file/d/1LsQzt-0iGv74NtQw_fQ_tYOcGK_F6wQu/view?usp=drive_link">
                <button>Презентация команды</button>            
              </a>

            </div>            
          </div>          
        </div>
      </div>

      <div className="Block">
        <div className="Project--Container">
          <div className="Project--Avatar">
            <img width={500} src={gm}  alt="logo" />          
          </div>
          <div className="Project--Container--Item">
            <div>
              <h2>Команда GM</h2>
              <h2>Олёкминск для туристов</h2>                  
            </div>
            <div>
              <p>Наш проект называется сайт ‘’Олёкминск для туристов’’
                решает проблему чтобы туристы больше знали о городе и для их удобств 
                у  Целевой аудитории с 12 лет люди проживающие на Олёкминском районе
                с помощью сайта: “город Олёкминск для туристов” Решение: чтобы туристы пользовались сайтом Уникальность: в простоте и доступности.
              </p>          
            </div>       
            <div>

              <a className="Stream-items--button" href="https://drive.google.com/file/d/1kg9lrfIEYivDO_0_MflFfTRFyJJregFh/view?usp=sharing">
                <button>Презентация команды</button>            
              </a>

            </div>       
          </div>          
        </div>
      </div>

    </div>      
    </div>
 
  )
}
export default Streams1;